(function (window) {
  'use strict';

  // Base installation shells. Fixture name/image/variant lists come from
  // leaves-configurator-fixtures.js (synced from live Tepo Basic/Vibrant options).
  // Display order (L→R, top→bottom): ceiling hanging, wall, floor track,
  // ground, wrap, ceiling track, then remaining wall track + suspended.
  var installationDefinitions = [
    {
      id: 'ceiling_hanging',
      label: 'Ceiling hanging',
      pluginLabel: '吸顶吊装',
      handle: 'outdoor-ceiling-hanging-light-color-bridge',
      family: 'color_bridge',
      cartVariantId: '47819817910498',
      pluginOptionSetId: '159722',
    },
    {
      id: 'mounted_hanging',
      label: 'Wall-mounted hanging',
      pluginLabel: '壁挂吊装',
      handle: 'outdoor-mounted-hanging-light-color-bridge',
      family: 'color_bridge',
      cartVariantId: '47819816304866',
      pluginOptionSetId: '159723',
    },
    {
      id: 'floor_track',
      label: 'Floor track',
      pluginLabel: '地面轨道',
      handle: 'outdoor-lnt-track-system',
      family: 'lnt',
      cartVariantId: '47266789425378',
      pluginOptionSetId: '150880',
    },
    {
      id: 'ground_spike',
      label: 'Ground spike',
      pluginLabel: '地插',
      handle: 'outdoor-ground-spike-lightcolor-bridge',
      family: 'color_bridge',
      cartVariantId: '47819818893538',
      pluginOptionSetId: '159720',
    },
    {
      id: 'wrap_around',
      label: 'Wrap-around',
      pluginLabel: '环绕安装',
      handle: 'outdoor-wrap-around-light-color-bridge',
      family: 'color_bridge',
      cartVariantId: '47819810177250',
      pluginOptionSetId: '165144',
    },
    {
      id: 'ceiling_track',
      label: 'Ceiling track',
      pluginLabel: '吸顶轨道',
      handle: 'outdoor-ceiling-track-light-lnt',
      family: 'lnt',
      cartVariantId: '47819807260898',
      pluginOptionSetId: '165142',
    },
    {
      id: 'wall_track',
      label: 'Wall track',
      pluginLabel: '墙装轨道',
      handle: 'outdoor-wall-track-light-lnt',
      family: 'lnt',
      cartVariantId: '47819800379618',
      pluginOptionSetId: '165141',
    },
    {
      id: 'suspended',
      label: 'Suspended',
      pluginLabel: '吊装',
      handle: 'outdoor-suspended-light-color-bridge',
      family: 'color_bridge',
      cartVariantId: '47819813093602',
      pluginOptionSetId: '165143',
    },
  ];

  function emptyFixtures() {
    return { basic: [], vibrant: [] };
  }

  function applySyncedFixtures(installation) {
    var pack =
      window.LEAVES_CONFIGURATOR_FIXTURES &&
      window.LEAVES_CONFIGURATOR_FIXTURES.installations &&
      window.LEAVES_CONFIGURATOR_FIXTURES.installations[installation.id];
    if (!pack) {
      return Object.assign({}, installation, {
        allowedLengths: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        trackSkus: [],
        tracks: [],
        fixturesByShape: emptyFixtures(),
      });
    }
    if (pack.cartVariantId) installation.cartVariantId = String(pack.cartVariantId);
    if (pack.pluginOptionSetId) installation.pluginOptionSetId = String(pack.pluginOptionSetId);
    if (pack.handle) installation.handle = pack.handle;
    if (pack.family) installation.family = pack.family;
    var tracks = Array.isArray(pack.tracks) ? pack.tracks : [];
    return Object.assign({}, installation, {
      allowedLengths: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      trackChoice: pack.trackChoice || '',
      trackSkus: tracks.map(function (t) {
        return t.id || t.sku;
      }),
      tracks: tracks,
      fixturesByShape: {
        basic: (pack.fixturesByShape && pack.fixturesByShape.basic) || [],
        vibrant: (pack.fixturesByShape && pack.fixturesByShape.vibrant) || [],
      },
    });
  }

  var rules = {
    version: 'variant-mapping-tepo-fixtures-sync-2026-09-18',
    status: 'validated',
    cartEnabled: true,
    cartMode: 'tepo_installations', // Shopify nested variants. Does not call Qikify/Tepo.
    configuratorVariant: {
      productHandle: '户外定制灯具',
      adminGid: 'gid://shopify/ProductVariant/47286017294562',
      cartVariantId: '47286017294562',
    },
    // Product-page Multiple lighting parents (1 install still uses each installation product).
    multipleLightingByBranchCount: {
      2: {
        label: 'Two sets of lighting fixtures (custom made)',
        productHandle: '2套灯具组合',
        cartVariantId: '48197705564386',
        pluginOptionSetId: '169421',
      },
      3: {
        label: 'Three sets of lighting fixtures (custom made)',
        productHandle: '户外定制灯具',
        cartVariantId: '47286017294562',
        pluginOptionSetId: '171663',
      },
    },
    pricing: {
      productHandles: ['leaves-lighting', 'leaves-lnt', 'leaves-color-bridge-cable', 'leaves-parts', '户外定制灯具', '2套灯具组合', '彩桥线', 'lighting', 'lnt', '配件'].concat(
        installationDefinitions.map(function (item) {
          return item.handle;
        })
      ),
    },
    pluginOptionSetId: '165144',
    maxInstallations: 3,
    maxTotalFixtures: 6,
    maxLengthMeters: 15,
    minLengthMeters: 3,
    colors: [
      { id: 'black', label: 'DGX-P-18 Black', value: '黑色', tepoDisplay: 'DGX-P-18黑' },
      { id: 'blue', label: 'DGX-P-18 Blue', value: '蓝色', tepoDisplay: 'DGX-P-18蓝' },
      { id: 'yellow', label: 'DGX-P-18 Yellow', value: '黄色', tepoDisplay: 'DGX-P-18黄' },
      { id: 'green', label: 'DGX-P-18 Green', value: '绿色', tepoDisplay: 'DGX-P-18绿' },
    ],
    shapes: [
      { id: 'basic', label: 'Basic model' },
      { id: 'vibrant', label: 'Vibrant Color model' },
    ],
    lightingModes: [
      { id: 'cw', label: 'Dim only' },
      { id: 'rgb', label: 'Color + dim' },
    ],
    adapter: { variantId: null, sku: null, label: 'Adapter', productHandle: null },
    splittersByBranchCount: {
      1: {
        variantId: null,
        sku: null,
        label: 'Direct connection',
        optionValue: '直连',
        productHandle: null,
      },
      2: {
        variantId: null,
        sku: null,
        label: '1-to-2 splitter',
        optionValue: '一分二',
        productHandle: null,
      },
      3: {
        variantId: null,
        sku: null,
        label: '1-to-3 splitter',
        optionValue: '一分三',
        productHandle: null,
      },
    },
    sharedCableByColorAndLength: {},
    installations: installationDefinitions.map(applySyncedFixtures),
  };

  rules.colors.forEach(function (color) {
    rules.sharedCableByColorAndLength[color.id] = {};
    for (var length = 3; length <= 15; length += 1) {
      rules.sharedCableByColorAndLength[color.id][length] = {
        variantId: null,
        cartVariantId: null,
        sku: null,
        productHandle: 'leaves-color-bridge-cable',
        colorValue: color.value,
        lengthMeters: length,
        label: color.label + ' · ' + length + 'm shared cable',
      };
    }
  });

  if (
    window.LEAVES_CONFIGURATOR_VARIANT_MAP &&
    window.LEAVES_CONFIGURATOR_PRICING &&
    typeof window.LEAVES_CONFIGURATOR_PRICING.applyVariantMapToRules === 'function'
  ) {
    window.LEAVES_CONFIGURATOR_PRICING.applyVariantMapToRules(
      rules,
      window.LEAVES_CONFIGURATOR_VARIANT_MAP
    );
  } else if (window.LEAVES_CONFIGURATOR_VARIANT_MAP) {
    rules._pendingVariantMap = window.LEAVES_CONFIGURATOR_VARIANT_MAP;
  }

  window.LEAVES_CONFIGURATOR_RULES = rules;
})(window);
